import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconWifi = (props) => (
  <Icon viewBox="0 0 24 30" fill="none" {...props}>
    <path
      d="M4 10.4485C5.05788 11.716 5.6682 13.3676 5.6682 15.0576C5.6682 16.7092 5.09857 18.2839 4.08138 19.5898"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.73694 7.2991C11.2831 9.56522 12.0968 12.2538 12.0968 15.0577C12.0968 17.7847 11.2831 20.4349 9.77763 22.701"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.474 4.14943C17.5084 7.41418 18.6069 11.1782 18.6069 15.0575C18.6069 18.8984 17.5491 22.624 15.5147 25.8504"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.1702 1C23.7335 5.22497 25.0762 10.0645 25.0762 15.0576C25.0762 20.0123 23.7335 24.8134 21.2109 29"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
